<template>
  <client-only>
    <div id="user-detail-warp">
      <v-layout align-baseline wrap>
        <v-form
          id="user-details-form"
          ref="formuser"
          v-model="valid"
          class="rtl pa-0 mt-2"
          @keydown.enter="validate"
          lazy-validation
        >
          <v-row class="px-2">
            <v-col cols="12" md="3" class="py-0">
              <p class="display-18 font-weight-medium text-align-center">
                <span class="primary--text">*</span>
                {{ cvPopup.firstName }}
              </p>
              <TextField
                :fieldLabel="'שם פרטי'"
                :fieldIconName="'mdi-account'"
                :current-value="currentFirstName"
                @child-field="applyFirstName"
                v-model="firstName"
              />
            </v-col>
            <v-col cols="12" md="3" class="py-0">
              <p class="display-18 font-weight-medium text-align-center">
                <span class="primary--text">*</span>
                {{ cvPopup.lastName }}
              </p>
              <TextField
                :fieldLabel="'שם משפחה'"
                :fieldIconName="'mdi-account'"
                :current-value="currentLastName"
                @child-field="applyLastName"
                v-model="lastName"
              />
            </v-col>
            <v-col cols="12" md="3" class="py-0">
              <p class="display-18 font-weight-medium text-align-center">
                <span class="primary--text">*</span>
                {{ cvPopup.email }}
              </p>

              <v-text-field
                solo
                :label="email"
                prepend-inner-icon="mdi-email-outline"
                rounded
                outlined
                dense
                :disabled="true"
                dir="auto"
                auto
              />
            </v-col>
            <v-col cols="12" md="3" class="py-0">
              <p class="display-18 font-weight-medium text-align-center">
                <span class="primary--text">*</span>
                {{ cvPopup.phoneNum }}
              </p>

              <PhoneNumberField
                :current-phone="currentPhone"
                :show-error="true"
                @updateNumber="handleUpdatePhone"
              />
            </v-col>
          </v-row>
          <v-row class="px-2">
            <v-col cols="12" md="3" class="py-0">
              <p class="display-18 font-weight-medium text-align-center">
                <!-- <span class="primary--text">*</span> -->
                {{ cvPopup.settlement }}
              </p>

              <LocationFieldNew
                @updateLocation="handleUpdateLocation"
                :current-location="currentLocation"
              />
            </v-col>
            <v-col cols="12" md="3" class="py-0">
              <p class="display-18 font-weight-medium text-align-center">
                <!-- <span class="primary--text">*</span> -->
                {{ cvPopup.lastPosition }}
              </p>
              <LastPositionField
                v-model="lastPosition"
                :current-last-position="
                  currentLastPosition === 'לא רלוונטי'
                    ? ''
                    : currentLastPosition
                "
              />
              <!-- @updatePosition="handleUpdatePosition" -->
            </v-col>
            <v-col cols="12" md="3" class="py-0">
              <p class="display-18 font-weight-medium text-align-center">
                <span class="primary--text">*</span>
                {{ cvPopup.experience }}
              </p>
              <ComboBoxField
                :current-experience="currentExperience"
                @updateExperience="handleUpdateExperience"
              />
            </v-col>
            <v-col cols="12" md="3" class="py-0" v-if="showBirthYear">
              <p class="display-18 font-weight-medium text-align-center">
                {{ cvPopup.birthDate }}
              </p>

              <YearField
                :current-birth-year="currentBirthYear"
                @yearSelected="handleYearUpdate"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-layout>

      <v-layout v-show="displaySave" justify-start pa-0 column>
        <v-flex>
          <SendToSimilarJobs
            :similar="currentSimilar"
            v-if="showSimilarCheckBox"
          />
        </v-flex>
        <v-flex xs12 pa-0 ma-0 text-right>
          <small class="red--text">*שדות חובה</small>
        </v-flex>
      </v-layout>
      <v-layout v-show="displaySave" justify-end pa-0>
        <v-flex xs12 pa-0 text-center>
          <v-btn
            ref="showAll"
            @click="sendUpdatedDetails('default')"
            :loading="inProcess"
            rounded
            class="orange_btn_large"
            :disabled="!valid"
          >
            {{ cvPopup.saveEdit }}
          </v-btn>
        </v-flex>
      </v-layout>
      <v-row>
        <v-col class="py-0">
          <small class="red--text" v-show="showUpdateError">
            {{ updateErrorTxt }}
          </small>
        </v-col>
      </v-row>
    </div>
  </client-only>
</template>


<script>
import { t } from '@/store/modules/homeDrushim/constantsContent';
import TextField from '@/components/Forms/Form_Fields/TextField';

import LastPositionField from '@/components/Forms/Form_Fields/LastPositionField';
import PhoneNumberField from '@/components/Forms/Form_Fields/PhoneNumberField';
import LocationFieldNew from '@/components/Forms/Form_Fields/LocationFieldNew';

import ComboBoxField from '@/components/Forms/Form_Fields/ComboBoxField';
import YearField from '@/components/Forms/Form_Fields/YearField';
import SendToSimilarJobs from '@/components/Forms/Form_Fields/SendToSimilarJobs';

import CurrentUser from '@/components/mixins/CurrentUser';
import { UPDATE_PROFILE } from '@/lib/api.js';
import errors from '@/lib/errorsList';
import sanitizeHtml from '@/plugins/sanitize';

const MIN_POS_LENGTH = 1;

export default {
  mixins: [CurrentUser],
  components: {
    TextField,

    LocationFieldNew,
    YearField,
    LastPositionField,
    PhoneNumberField,
    ComboBoxField,
    SendToSimilarJobs
  },

  props: {
    displaySave: {
      type: Boolean,
      default: false,
      required: false
    },
    showBirthYear: {
      type: Boolean,
      required: false
    },
    /** props if should active OTP on page*/
    activateOtpOnPage: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      valid: true,
      cvPopup: t('titles.CV_Popup'),
      grid: 'xl4 lg4 md4 sm12 xs12',
      firstName: null,
      lastName: null,
      phone: null,
      location: null,
      lastPosition: '',
      experience: null,
      birthYear: null,
      showUpdateError: false,
      updateErrorTxt: null,
      sendToSimilarJobs: null,
      inProcess: false,
      cityId: null
    };
  },

  computed: {
    isValid() {
      return this.validate();
    },

    currUserDetails() {
      return this.CurrentUser;
    },
    email() {
      return this.currUserDetails ? this.currUserDetails.Email : '';
    },

    currentFirstName() {
      return this.currUserDetails ? this.currUserDetails.FirstName : '';
    },

    currentLastName() {
      return this.currUserDetails ? this.currUserDetails.LastName : '';
    },

    currentPhone() {
      return this.currUserDetails &&
        this.currUserDetails.Profile &&
        this.currUserDetails.Profile.Phone
        ? this.currUserDetails.Profile.Phone
        : null;
    },

    currentLocation() {
      return this.currUserDetails &&
        this.currUserDetails.Profile &&
        this.currUserDetails.Profile.Location
        ? this.currUserDetails.Profile.Location
        : null;
    },

    currentLastPosition() {
      return this.currUserDetails &&
        this.currUserDetails.Profile &&
        this.currUserDetails.Profile.LastPosition
        ? this.currUserDetails.Profile.LastPosition
        : null;
    },
    currentBirthYear() {
      return this.currUserDetails &&
        this.currUserDetails.Profile &&
        this.currUserDetails.Profile.BirthYear
        ? this.currUserDetails.Profile.BirthYear
        : null;
    },
    currentExperience() {
      return this.currUserDetails &&
        this.currUserDetails.Profile &&
        this.currUserDetails.Profile.Experience &&
        this.currUserDetails.Profile.Experience.Id
        ? this.currUserDetails.Profile.Experience
        : null;
    },
    currentSimilar() {
      return this.currUserDetails && this.currUserDetails.Profile
        ? this.currUserDetails.Profile.SendToSimilarJobs
        : null;
    },

    showSimilarCheckBox() {
      return this.currentSimilar !== null;
    }
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.formuser.validate();
    });
  },
  watch: {
    isValid(val) {
      this.$emit('formValidated', val);
    }
  },

  created() {
    this.initDetails();
  },

  mounted() {
    /**
     * @param {Boolean } checkbox form CVPopup
     */

    this.$nuxt.$on('sendToSimilar', this.sendToSimilarJob);
    this.$nuxt.$on('sendUserDetailsUpdate', this.sendUpdatedDetails);
  },

  beforeDestroy() {
    this.$nuxt.$off('sendUserDetailsUpdate', this.sendUpdatedDetails);
    this.$nuxt.$off('sendToSimilar', this.sendToSimilarJob);
  },

  methods: {
    /**
     * TODO show only once on CVpopup
     *
     * @param {Boolean} val sendToSimilarJobs
     * updates  on user profile
     */

    sendToSimilarJob(val) {
      this.sendToSimilarJobs = val;
    },
    // async fetchUserProfile() {
    //   await this.$auth.fetchUser();
    // },

    applyFirstName(val) {
      this.firstName = val;
    },

    applyLastName(val) {
      this.lastName = val;
    },

    handleYearUpdate(year) {
      this.birthYear = Number(year) > 0 ? Number(year) : null;
    },

    // handleUpdatePosition(position) {
    //   this.lastPosition = position;
    // },

    handleUpdateLocation(location) {
      this.cityId = location ? location.Code : null;
    },

    handleUpdatePhone(phoneNum) {
      this.phone = phoneNum;
    },

    handleUpdateExperience(experience) {
      this.experience = experience;
    },
    validate() {
      return (
        this.validateFieldLength(this.firstName) &&
        this.validateFieldLength(this.lastName) &&
        // this.validateFieldLength(this.lastPosition) &&
        this.experience !== null &&
        /[0][5]\d{8}$/.test(this.phone)
        // && this.cityId
      );
    },

    validateFieldLength(value) {
      return value && value.length >= MIN_POS_LENGTH;
    },

    getSafeHtml(value) {
      let sanitize = this.$sanitize(value);
      return this.sanitizeForExcel(sanitize);
    },

    sanitizeForExcel(value) {
      if (typeof value === 'string' && /^[=+\-@]/.test(value)) {
        return `'${value}`;
      }
      return value;
    },

    initDetails() {
      this.firstName = this.currentFirstName;
      this.lastName = this.currentLastName;
      this.phone = this.currentPhone;
      this.lastPosition = this.currentLastPosition;
      this.birthYear = this.currentBirthYear;
      this.experience = this.currentExperience
        ? this.currentExperience.Id
        : null;
      this.cityId = this.currentLocation ? this.currentLocation.CityId : null;
    },
    /**
     *
     * @param {action} String - represent the feature that trigger the otp dialog (save user details, sign-in, signup, send cv)
     */
    async sendUpdatedDetails(action) {
      this.inProcess = true;
      if (this.$refs.formuser.validate()) {
        this.showUpdateError = false;
        const data = {
          FirstName: this.getSafeHtml(this.firstName),
          LastName: this.getSafeHtml(this.lastName),
          Phone: this.phone,
          LastPosition: this.lastPosition
            ? this.getSafeHtml(this.lastPosition)
            : 'לא צוין',
          BirthYear: this.birthYear,
          City: this.cityId ? this.cityId : 1201,
          Experience: this.experience,
          SendToSimilarJobs:
            this.sendToSimilarJobs === null ? true : this.sendToSimilarJobs
        };

        /**
         * emit @Boolean to spinner indicator gif in CVDetails Component
         */
        this.$nuxt.$emit('inProgress', true);

        return await this.$axios
          .post(`${UPDATE_PROFILE}`, data)
          .then(res => {
            if (res.data.IsError) {
              throw res.data.ErrorsMessages;
            }

            this.$auth.fetchUser().then(() => {
              if (this.activateOtpOnPage) {
                this.$nuxt.$emit('openOTP', action);
              } else {
                console.log('Otp not active here');
              }
              console.log('done fetchUser');
            });

            this.$nuxt.$emit('inProgress', false);
            this.inProcess = false;

            /**
             * only on personal pages edit
             */
            if (this.displaySave) {
              this.$nuxt.$emit('toggleEditForm');
            }

            return {
              valid: true,
              error: null
            };
          })
          .catch(err => {
            console.log('FAILURE!!', err);
            let errNum = Object.keys(err)[0];
            let errMsg = errors[errNum];
            this.updateErrorTxt = 'שגיאה ' + errMsg;
            this.showUpdateError = true;
            this.$nuxt.$emit('inProgress', false);
            this.inProcess = false;
            return {
              valid: true,
              error: err
            };
          });
        // send the updates
      } else {
        this.$nuxt.$emit('inProgress', false);
        this.inProcess = false;
        this.$emit('disableSendCV');
        return { valid: false, error: null };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#user-detail-warp {
  margin: 0 auto;
}

#user-detail-warp .layout .flex {
  margin: 0;
  padding: 0 10px;
}

.flex p {
  text-align: right;
  margin: 0 10px 5px;
}

@media only screen and (min-width: 920px) {
  .flex p {
    display: block;
  }
}
</style>
